var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcStatusNightFill = function SvgIcStatusNightFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.992 10.242c-.842 0-1.3-.946-.758-1.565L5.66 5.905H4.14c-.547 0-.99-.427-.99-.953S3.593 4 4.14 4h3.646c.841 0 1.299.946.757 1.565L6.118 8.338H7.74c.547 0 .99.426.99.952s-.443.952-.99.952zM13.935 8.887a6.2 6.2 0 0 0-1.123-3.557c-.39-.56.078-1.302.774-1.23C17.79 4.538 21 7.927 21 12.01 21 16.421 17.28 20 12.694 20c-2.804 0-5.371-1.35-6.904-3.553-.39-.561.08-1.305.777-1.23.077.008.14.016.267.033.237.031.336.041.445.041 3.676 0 6.656-2.867 6.656-6.404"
  })));
};
export default SvgIcStatusNightFill;